import React from 'react'
import { ChakraProvider } from '@chakra-ui/react'
import './layout.css'
import theme from '../theme'
import Header from '../components/Header/Header'
import Footer from './Footer/Footer'
import { useStaticQuery, graphql } from 'gatsby'

const Layout = (props) => {
    const { children } = props;
    
    const data = useStaticQuery(graphql`
    {
      prismicSitewideAlert {
        data {
          show_alert
          alert_content {
            richText
          }
          show_alert_modal_dialog
          dialog_content {
            richText
          }
        }
      }
    }
    `)
    console.log('data', data)

    // Layout has access history, location and match props
    return (
        <ChakraProvider resetCSS theme={theme}>
            <div className="site">
                <Header location={props.pageLocation} alert={data?.prismicSitewideAlert?.data} />
                    <main>{children}</main>
                <Footer />
            </div>
        </ChakraProvider>
    )
}

export default Layout;